// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setEndDate = createAction('[Scatter Plot] Set End Date', props());
